<template>
  <div class="real-shipment">
    <!-- PROJECT INFO -->
    <section class="section">
      <b-row>
        <b-col md="12">
          <b-button
            variant="primary"
            class="float-right mr-1"
            size="sm"
            type="button"
            @click="openSlideFormRealShipment('ADD', null, null)"
          >
            <i class="fa fa-plus"></i>
            &nbsp; ADD REAL SHIPMENT
          </b-button>
        </b-col>
      </b-row>
      <div class="section-title">
        <h5>PROJECT INFO</h5>
      </div>
      <div class="info-grid px-3">
        <div class="left">
          <div class="row">
            <div class="label">Company Name</div>
            <div class="colon">:</div>
            <div class="value">{{ projectData?.company?.company }}</div>
          </div>
          <div class="row">
            <div class="label">Fleet Ownership</div>
            <div class="colon">:</div>
            <div class="value">{{ projectData?.fleet_ownership }}</div>
          </div>
          <div class="row">
            <div class="label">Fleet Type</div>
            <div class="colon">:</div>
            <div class="value chips">
              <span
                v-for="(item, index) in projectData?.fleet_type_ids"
                :key="index"
                class="chip"
              >
                {{ item?.text }}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="label">Period</div>
            <div class="colon">:</div>
            <div class="value">
              {{
                projectData?.period && projectData?.period.length === 2
                  ? `${moment(projectData.period[0]).format(
                      'DD/MM/YYYY'
                    )} - ${moment(projectData.period[1]).format('DD/MM/YYYY')}`
                  : '-'
              }}
            </div>
          </div>
          <div class="row">
            <div class="label">Shipment Plan Number</div>
            <div class="colon">:</div>
            <div class="value">ownship-sfc-2509-0003</div>
          </div>
          <div class="row">
            <div class="label">Contract Type</div>
            <div class="colon">:</div>
            <div class="value">
              <div>{{ projectData?.contract_type?.name || '-' }}</div>
              <div class="badge-info" v-if="projectData?.contract_type?.is_spal">
                <i class="fa fa-info-circle"></i>
                This type using SPAL
              </div>
            </div>
          </div>
          <div class="row">
            <div class="label">Term</div>
            <div class="colon">:</div>
            <div class="value">{{ projectData?.terms?.code }}</div>
          </div>
        </div>
        <div class="right">
          <div class="row">
            <div class="label">Port of Loading</div>
            <div class="colon">:</div>
            <div class="value">Bengalon</div>
          </div>
          <div class="row">
            <div class="label">Port of Discharging</div>
            <div class="colon">:</div>
            <div class="value">Paiton</div>
          </div>
          <div class="row">
            <div class="label">Distance</div>
            <div class="colon">:</div>
            <div class="value">{{ projectData?.distance }}</div>
          </div>
          <div class="row">
            <div class="label">Laycan</div>
            <div class="colon">:</div>
            <div class="value">
              {{
                projectData?.laycan && projectData?.laycan.length === 2
                  ? `${moment(projectData?.laycan[0]).format(
                      'DD/MM/YYYY'
                    )} - ${moment(projectData?.laycan[1]).format('DD/MM/YYYY')}`
                  : '-'
              }}
            </div>
          </div>
          <div class="row">
            <div class="label">Cargo Type</div>
            <div class="colon">:</div>
            <div class="value">{{ projectData?.cargo_type?.name }}</div>
          </div>
          <div class="row">
            <div class="label">Total Plan QTY</div>
            <div class="colon">:</div>
            <div class="value">{{ projectData?.total_quantity }}</div>
          </div>
          <div class="row">
            <div class="label">Remarks</div>
            <div class="colon">:</div>
            <div class="value">{{ projectData?.remarks }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- DETAIL SHIPMENT PLAN -->
    <section class="section">
      <div class="section-title">
        <h5>DETAIL SHIPMENT PLAN</h5>
      </div>
      <div class="table-wrap">
        <table class="table-custom">
          <thead>
            <tr>
              <th class="check"></th>
              <th>Number Detail Plan</th>
              <th>Fleet</th>
              <th>Cargo Type</th>
              <th>Plan QTY</th>
              <th>Status</th>
              <th>Description</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody v-if="projectData?.project_contract_plan?.length > 0">
            <tr
              v-for="(val, index) in projectData?.project_contract_plan"
              :key="index"
            >
              <td class="check"><b-form-checkbox v-model="val.checked" /></td>
              <td>
                <a href="#" class="link">
                  {{ val?.shipment_plan_detail_number }}
                </a>
              </td>
              <td>
                <span
                  class="badge-fleet mr-1"
                  v-for="(obj, objIndex) in val?.fleets"
                  :key="objIndex"
                >
                  {{ showVehicleName(obj.vehicle_id) }}
                </span>
              </td>
              <td>{{ val?.cargo_type?.name }}</td>
              <td>
                {{ val?.plan_quantity?.toLocaleString() }} {{ projectData?.unit }}
              </td>
              <td class="text-uppercase">{{ val?.status }}</td>
              <td>
                <b-button size="sm" variant="primary" class="btn-desc">
                  Description
                </b-button>
              </td>
              <td>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  class="btn-remarks"
                >
                  Remarks
                </b-button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="8" class="text-center text-muted">
                No detail shipment plan.
              </td>
            </tr>
          </tbody>
        </table>
        <b-sidebar
          v-model="slideFormRealShipment"
          id="slideFormRealShipment"
          :title="`Create Real Shipment`"
          width="100%"
          backdrop-variant="dark"
          bg-variant="white"
          right
          backdrop
          shadow
        >
          <template #default="{ hide }">
            <SlideFormRealShipment
              :closeSlideFormRealShipment="closeSlideFormRealShipment"
              :refreshData="fetchRealShipment"
              :optionsFleets="optionsFleets"
              :projectId="projectData?.id"
              :action="action"
              :detailRealShipment="detailRealShipment"
              :showVehicleName="showVehicleName"
            />
          </template>
        </b-sidebar>
      </div>
    </section>

    <!-- FLEET OPERATIONS -->
    <section class="section">
      <div class="section-title">
        <h5>FLEET OPERATIONS</h5>
      </div>
      <div class="table-wrap" style="overflow-x: auto">
        <table class="table-custom">
          <thead>
            <tr>
              <th>No</th>
              <th>Status</th>
              <th>Detail Plan</th>
              <th>ETA POL</th>
              <th>ETA POD</th>
              <th>Plan QTY</th>
              <th>Fleet</th>
              <th>Cargo Type</th>
              <th>Cargo Loading</th>
              <th>Cargo Unloading</th>
              <th>POL</th>
              <th>TA POL</th>
              <th>Berthing</th>
              <th>Commenced</th>
              <th>Completed</th>
              <th>POD</th>
              <th>TA POD</th>
              <th>Berthing</th>
              <th>Commenced</th>
              <th>Completed</th>
              <th>Price</th>
              <th>Price To Vendor</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="listRealShipment && listRealShipment.length > 0">
            <tr v-for="(state, index) in listRealShipment" :key="index">
              <td>{{ index + 1 }}</td>
              <td class="text-capitalize">{{ state?.status }}</td>
              <td>{{ state?.project_plan?.shipment_plan_detail_number }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.startDate }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.endDate }}</td>
              <td>{{ state?.project_plan?.plan_quantity?.toLocaleString() }}</td>
              <td>
                <span
                  class="badge-fleet mr-1"
                  v-for="(obj, objIndex) in state?.dataTrip?.vehicle"
                  :key="objIndex"
                >
                  {{ obj?.name }}
                </span>
              </td>
              <td>{{ state?.dataTrip?.tripRecord?.cargoType }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.cargoLoading?.toLocaleString() }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.cargoUnloading?.toLocaleString() }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.portLoading?.portName }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.polArrivalTime }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.polBerthing }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.polCommenced }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.polCompleted }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.portDischarge?.portName }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.podArrivalTime }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.podBerthing }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.podCommenced }}</td>
              <td>{{ state?.dataTrip?.tripRecord?.podCompleted }}</td>
              <td class="text-right">{{ state?.price?.toLocaleString() }}</td>
              <td class="text-right">{{ state?.price_to_vendor?.toLocaleString() }}</td>
              <td>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="openSlideFormRealShipment('DETAIL', state?.id, state)"
                >
                  <i class="fa fa-eye mr-1"></i> Detail
                </b-button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="23" class="text-center text-muted">
                No Data Real Shipment.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import SlideFormRealShipment from './SlideFormRealShipment.vue'

export default {
  name: 'TabRealShipmentNew',
  components: {
    SlideFormRealShipment,
  },
  props: {
    projectData: { type: Object, default: null },
    optionsFleets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      listRealShipment: [],
      action: '',
      slideFormRealShipment: false,
      detailRealShipment: null,
      id: null,
    }
  },
  mounted() {
    this.fetchRealShipment()
  },
  methods: {
    async fetchRealShipment() {
      try {
        const response = await this.$store.dispatch(
          'busdev/fetchListRealShipment',
          {
            project_contract_id: this.projectData.id,
            params: {
              perPage: 25,
              page: 1,
            },
          }
        )
        this.listRealShipment = response?.data?.data?.data
        return response
      } catch (e) {
        return e
      }
    },
    openSlideFormRealShipment(value, id, data) {
      this.id = null
      this.action = value
      this.slideFormRealShipment = !this.slideFormRealShipment
      this.detailRealShipment = data
      if (id) this.id = id
    },
    showVehicleName(value) {
      let vehicle = this.optionsFleets.find((obj) => obj.value === value)

      return vehicle?.text ?? '-'
    },
    closeSlideFormRealShipment() {
      this.id = null
      this.action = ''
      this.slideFormRealShipment = false
      this.detailRealShipment = null
    },
  },
}
</script>

<style scoped>
.real-shipment {
  background: #fff;
  padding: 16px;
}
.section {
  margin-bottom: 32px;
}
.info-grid {
  display: flex;
  gap: 40px;
}
.info-grid .left,
.info-grid .right {
  flex: 1;
}
.row {
  display: flex;
  margin-bottom: 14px;
}
.label {
  width: 190px;
  color: #4a4a4a;
}
.colon {
  width: 14px;
  text-align: center;
}
.value {
  flex: 1;
  color: #1d1d1f;
}
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.chip {
  border: 1px solid #e5e7eb;
  background: #fff;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #374151;
}
.badge-info {
  display: inline-block;
  margin-top: 8px;
  background: #e9f1ff;
  color: #334697;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
}

.table-wrap {
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}
.table-custom {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.table-custom thead th {
  background: #f5f7fa;
  color: #273469;
  font-weight: 700;
  padding: 18px;
  border-bottom: 1px solid #e5e7eb;
}
.table-custom tbody td {
  padding: 18px;
  border-bottom: 1px solid #e5e7eb;
  color: #1d1d1f;
  vertical-align: middle;
}
.table-custom .check {
  width: 52px;
  text-align: center;
}
.badge-fleet {
  background: #334697;
  color: #fff;
  font-weight: 700;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
}
.btn-desc {
  background: #334697;
  border-color: #334697;
  font-weight: 600;
  min-width: 140px;
}
.btn-remarks {
  color: #334697;
  border-color: #334697;
  font-weight: 600;
  min-width: 120px;
}
.link {
  color: #273469;
  text-decoration: underline;
}

.date-input {
  width: 320px;
}
</style>
